import { createComponent, FelaComponent } from "react-fela";
import { textStyles } from "~/styleguide/typography";
import { combineRules } from "fela";

/**
 * Displays a vertical list of related posts
 */

//  Deps
import get from "lodash.get";
import { fluid } from "~/styleguide/utils";

// Components
import PostSummary from "~/components/resource/summary/post";

export default ({ resource }) => {
    const related = get(resource, "acf.related_posts");

    if (!related || !related.length) return null;

    return (
        <RelatedPosts>
            <FelaComponent
                as="h4"
                style={combineRules(
                    textStyles.sidebarHeading,
                    relatedPostsHeading
                )}
            >
                Related Recommendations
            </FelaComponent>
            {related.map(({ post }, index) => {
                return <PostSummary resource={post} key={index} />;
            })}
        </RelatedPosts>
    );
};

const relatedPostsStyles = {
    extend: [fluid("margin-top", { max: 75, min: 30 })]
};

const relatedPostsHeading = {
    borderBottom: "1px solid #979797",
    paddingBottom: 20,
    marginBottom: 30
};

const RelatedPosts = createComponent(relatedPostsStyles, "div");
